// Determine if device is iphone or mac or browser is safari
export const isAppleDevice = () => {
  const userAgent = window.navigator.userAgent

  if (typeof window['safari'] !== 'undefined') {
    return 'Apple'
  }

  if (userAgent.includes('Macintosh') || userAgent.includes('iPhone')) {
    return 'Apple'
  }

  return ''
}

export const isMobileDevice = () => {
  if (/Mobi/.test(navigator.userAgent)) {
    return true
  } else {
    // greater than 1024px wide?
    return false
  }
}
